import React from 'react'

import { useReservationListItem } from './hooks/useReservationListItem'
import { Reservation, ReservationRecurrence } from 'models/Reservation'

import { 
  PatientInfo, 
  ReservationActions, 
  ReservationModals, 
  Tile
} from './components'

import * as S from './styles'

interface ReservationListItemProps {
  reservation: Reservation
  onRefresh: () => void
  allowActions?: boolean
  isAdmin?: boolean
  hideBorderTop?: boolean
}

export const ReservationListItem: React.FC<ReservationListItemProps> = ({
  reservation,
  onRefresh,
  allowActions = true,
  hideBorderTop = false
}) => {
  const {
    modalState,
    modalDispatch,
    handleClickCancelOption,
    handleClickRescheduleOption,
  } = useReservationListItem(reservation)

  const {
    startDate,
    recurrence,
    patientFullName,
    patientUsername,
    patientCellphone,
    creationDate,
  } = reservation
  
  return (
    <S.Container hideBorderTop={hideBorderTop}>
      <S.ReservationInfoWrapper>
        <Tile 
          date={startDate}
          isRecurrent={recurrence === ReservationRecurrence.WEEKLY} 
        />
      
        <PatientInfo 
          fullName={patientFullName}
          username={patientUsername}
          phoneNumber={patientCellphone}
          creationDate={creationDate}
        />
      </S.ReservationInfoWrapper>
      
      {allowActions && (
        <div>
          <ReservationActions 
            handleClickRescheduleOption={handleClickRescheduleOption}
            handleClickCancelOption={handleClickCancelOption}
          />

          <ReservationModals
            modalState={modalState}  
            modalDispatch={modalDispatch}
            onRefresh={onRefresh}
            reservation={reservation}
          /> 
        </div>
      )}
    </S.Container>
  )
}